export default "/assets/website/images/bio.jpg?0411298b98cd594a8ff0f6692bf512b0";